module.exports = __webpack_public_path__ + "img/adtitle_coupon.26072bf8.png";